let ScssStringifier = require('./scss-stringifier')

module.exports = function scssStringify (node, builder) {
  let str = new ScssStringifier(builder)
  str.stringify(node)
}
